import { Store } from "./rootReducer";
import { FieldHelperProps, FormikValues } from "formik";

export type Nullable<T> = T | null;

//Types
export enum ModalTypes {
  "OPEN_MODAL" = "OPEN_MODAL",
  "CLOSE_MODAL" = "CLOSE_MODAL",
  "UPLOAD_BUSINESS_DOCUMENT" = "UPLOAD_BUSINESS_DOCUMENT",
}

export type ResendCodeData = {
  phoneNumber: string;
};

// State
export type ModalState =
  | {
      modalType: null;
      data: null;
    }
  | {
      modalType: ModalTypes.UPLOAD_BUSINESS_DOCUMENT;
      data: {
        documentId: number;
        documentName: string;
        reloadTable: () => void;
        bRequired?: boolean;
        helpers?: FieldHelperProps<any>;
        values?: FormikValues;
        fieldName?: string;
      };
    };

export const initialState: ModalState = {
  modalType: null,
  data: null,
};

// Actions
export type Action =
  | {
      type: ModalTypes.OPEN_MODAL;
      payload: ModalState;
    }
  | {
      type: ModalTypes.CLOSE_MODAL;
      payload: null;
    };

// Reducer
export default function modalReducer(
  state = initialState,
  action: Action
): ModalState {
  switch (action.type) {
    case ModalTypes.OPEN_MODAL:
      return {
        ...action.payload,
      };
    case ModalTypes.CLOSE_MODAL:
      return {
        ...state,
        modalType: null,
        data: null,
      };
    default:
      return state;
  }
}

// Action creators
export const openModal = (payload: ModalState) => ({
  type: ModalTypes.OPEN_MODAL,
  payload,
});

export const closeModal = () => ({ type: ModalTypes.CLOSE_MODAL });

// Selectors
export const selectModalState = (state: Store) => state.globalModal;
